import React from 'react';
import './AuthBackground.css';
import logo from "../assets/sidecar-graphic.svg"; // Adjust path if needed


const AuthBackground = () => {
  return (
    <div className="auth-background">
      <div className="auth-background__gradient">
        <div className="auth-background__graphic">
          <img src={logo} alt="Guardify" />
        </div>
      </div>
    </div>
  );
};

export default AuthBackground; 